import React from 'react'
import Layout from '../../components/Layout'

const AppSettingsPage = () => {
    return (
        <React.Fragment>
            AppSettingsPage
        </React.Fragment>
    )
}

export default AppSettingsPage
